import React, { FC, PropsWithChildren } from 'react';
import clsx from 'classnames';

export const EmptyLayout: FC<PropsWithChildren<any>> = ({ children, className }) => (
  <div
    className={clsx(
      'w-full h-full min-h-full min-h-screen inset-0 p-0 m-0 overflow-hidden flex flex-col fixed',
      className,
    )}>
    {children}
  </div>
);
